module.exports = __webpack_public_path__ + "media/images/logos/publishers-association-12464b7bfb120f0a5a0d00f1c7e779ff.png";